/**
 * @description: 首页商品信息
 * @param
 * @return
 */
import request from '../utils/request';

export const goodsList = (params) => {
  return request.post('/web/common/commodityhot', params);
};

/**
 * @description: 按游戏分类，展示好物信息
 * @param  gid 游戏id(false)
 * @return
 */
export const AllList = (params) => {
  return request.post('/web/common/commodityall', params);
};

/**
 * @description: 商品明细
 * @param  id 商品id(true)
 * @return
 */
export const shopDetail = (params) => {
  return request.post('/web/common/getcommodity', params);
};

/**
 * @description: 产品列表
 * @param
 * @return
 */
export const AllProduct = (params) => {
  return request.post('/web/common/area', params);
};
// 获取购物车数量数字 @params uid
export const shoppingCarCount = (params) => {
  return request.post('/web/shopping/car/count', params);
};
// 获取购物车数量数字 @params uid page
export const shoppingCarList = (params) => {
  return request.post('/web/shopping/car/list', params);
};
// 添加购物车
export const addShoppingCar = (params) => {
  return request.post('/web/shopping/car/add', params);
};
// 删除购物车
export const delShoppingCarGoods = (params) => {
  return request.post('/web/shopping/car/delete', params);
};
// 购物车选中商品总费用
export const shoppingCarCost = (uid, params) => {
  return request.post(`/web/order/base/cost?uid=${uid}`, params, { requestBody: true });
};
// 结算页判断失效商品
export const invalidGoodsCheck = (params) => {
  return request.post('/web/common/invalidCheck', params);
};

// 获取实物商品的导航分类
export const getEntityClass = (params) => {
  return request.post('/web/common/group', params);
};
// 获取实物商品列表
export const getEntityList = (params) => {
  return request.post('/web/common/commodityEntityAll', params);
};
// 首页获取6个推荐实物
export const getHomeEntityHotGoods = (params) => {
  return request.post('/web/common/commodityEntityhot', params);
};



// WEBPACK FOOTER //
// src/api/good.js